"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextField = void 0;
var React = __importStar(require("react"));
var Flex_1 = require("../Flex");
var Label_1 = require("../Label");
var TextInput_1 = require("../TextInput");
var Typography_1 = require("../Typography");
exports.TextField = React.forwardRef(function (_a, ref) {
    var id = _a.id, label = _a.label, helperText = _a.helperText, error = _a.error, validation = _a.validation, textInputProps = __rest(_a, ["id", "label", "helperText", "error", "validation"]);
    var _b = React.useState(false), hasValidationError = _b[0], setHasValidationError = _b[1];
    var showHelperText = Boolean(helperText || (validation === null || validation === void 0 ? void 0 : validation.errorMessage));
    return (React.createElement(Flex_1.Flex, { flexDirection: "column" },
        React.createElement(Label_1.Label, { htmlFor: id, fontSize: "fontsize14", marginBottom: "space4" }, label),
        validation ? (React.createElement(TextInput_1.TextInput, __assign({ id: id, error: error || hasValidationError }, textInputProps, { onChange: function (e) {
                var isValid = validation.method(e.target.value);
                setHasValidationError(!isValid);
                if (isValid && validation.onSuccess) {
                    validation.onSuccess();
                }
                if (!isValid && validation.onError) {
                    validation.onError();
                }
                if (textInputProps.onChange) {
                    textInputProps.onChange(e);
                }
            }, ref: ref }))) : (React.createElement(TextInput_1.TextInput, __assign({ error: error }, textInputProps, { id: id, ref: ref }))),
        showHelperText && (React.createElement(Typography_1.Paragraph, { fontSize: 'fontsize14', marginY: 'space8', color: error || hasValidationError ? 'red600' : 'n900' }, hasValidationError && (validation === null || validation === void 0 ? void 0 : validation.errorMessage)
            ? validation.errorMessage
            : helperText))));
});
//# sourceMappingURL=index.js.map